import { MenuProvider } from '../../../../../services/exports/Constants';

export default {
  form: {
    provider: {
      label: 'Fournisseur de menu',
      options: {
        [null]: 'Sélectionner un fournisseur de menu',
        [MenuProvider.Lieferando]: 'Lieferando',
        [MenuProvider.Wolt]: 'Wolt',
        [MenuProvider.Deliveroo]: 'Deliveroo',
        [MenuProvider.UberEats]: 'Uber Eats',
        [MenuProvider.GloriaFood]: 'GloriaFood',
        [MenuProvider.Foodamigos]: 'Autre restaurant FoodAmigos',
        [MenuProvider.DoorDash]: 'DoorDash',
        [MenuProvider.Tabless]: 'Tabless (POS)',
        [MenuProvider.Thuisbezorgd]: 'Thuisbezorgd',
        [MenuProvider.TakeawayCom]: 'Takeaway.com',
        [MenuProvider.PysznePl]: 'Pyszne.pl',
        [MenuProvider.BistroSk]: 'Bistro.sk',
        [MenuProvider.JustEat]: 'Just Eat',
      },
    },
    provider_id: {
      [MenuProvider.Lieferando]: {
        label: 'URL Lieferando',
        placeholder: 'URL du restaurant sur Lieferando',
      },
      [MenuProvider.Wolt]: {
        label: 'URL Wolt',
        placeholder: 'URL du restaurant sur Wolt',
      },
      [MenuProvider.Deliveroo]: {
        label: 'Lien Deliveroo du restaurant',
        placeholder: 'https://deliveroo…/menu/city/area/restaurant',
        help: "Ouvrez votre restaurant sur Deliveroo et copiez le lien depuis la barre d'adresse.",
        error:
          "Saisissez le lien de la page du menu d'un restaurant sur Deliveroo. Il ressemble à ceci : https://deliveroo.co.uk/menu/city/area/restaurant-name.",
      },
      [MenuProvider.UberEats]: {
        label: 'URL Uber Eats',
        placeholder: 'URL du restaurant sur Uber Eats',
      },
      [MenuProvider.GloriaFood]: {
        label: 'Lien GloriaFood',
        placeholder: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
        help: {
          ordering_page: {
            title: 'Si vous utilisez la page de commande GloriaFood :',
            description: 'Saisissez votre URL de commande foodbooking.com.',
            example: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
          },
          embedded_widget: {
            title: 'Si GloriaFood est intégré à votre propre site web :',
            description: "Saisissez l'URL de la page de votre site où apparaît le widget de commande.",
            example: 'https://yourrestaurant.com/order',
          },
        },
        error: 'Saisissez un lien valide commençant par https://.',
        back_office_error:
          "Il s'agit d'un lien vers le back-office GloriaFood, pas de la page de commande de vos clients. Ouvrez la page de commande de votre restaurant et collez plutôt ce lien.",
        wrong_platform_error:
          "Ce lien ne semble pas être un lien GloriaFood. Si vous utilisez la page de commande hébergée par GloriaFood, saisissez votre URL de commande foodbooking.com. Si GloriaFood est intégré à votre propre site web, saisissez l'URL de la page où apparaît votre widget de commande.",
      },
      [MenuProvider.Thuisbezorgd]: {
        label: 'URL Thuisbezorgd',
        placeholder: 'URL du restaurant sur Thuisbezorgd',
      },
      [MenuProvider.TakeawayCom]: {
        label: 'URL Takeaway.com',
        placeholder: 'URL du restaurant sur Takeaway.com',
      },
      [MenuProvider.PysznePl]: {
        label: 'URL Pyszne.pl',
        placeholder: 'URL du restaurant sur Pyszne.pl',
      },
      [MenuProvider.BistroSk]: {
        label: 'URL Bistro.sk',
        placeholder: 'URL du restaurant sur Bistro.sk',
      },
      [MenuProvider.JustEat]: {
        label: 'URL Just Eat',
        placeholder: 'URL du restaurant sur Just Eat',
      },
      [MenuProvider.DoorDash]: {
        label: 'Lien DoorDash du restaurant',
        placeholder: 'https://www.doordash.com/store/…',
        help: "Ouvrez votre restaurant sur doordash.com et copiez le lien depuis la barre d'adresse.",
        error: "Saisissez le lien d'une page de restaurant DoorDash. Il commence par https://www.doordash.com/store/.",
        store_number_error:
          'Ce lien ne contient que le numéro de la boutique. Ouvrez le restaurant sur doordash.com et copiez le lien avec son nom, par exemple https://www.doordash.com/store/restaurant-name-123456/.',
      },
      [MenuProvider.Foodamigos]: {
        label: 'Restaurant source du menu',
        placeholder: 'Sélectionner le restaurant source du menu',
      },
    },
  },
};
